import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HStack, Spinner } from '@chakra-ui/react';
import { SectionContainer } from '#components';
import { useAuth } from '#contexts/auth';
import { Title } from './Github.styles';
import { t } from '#i18n';

export const Github = () => {
  const navigate = useNavigate();
  const { isAuthenticated, signIn } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      signIn();
    } else {
      navigate('/settings/organizations', { replace: true });
    }
  }, [isAuthenticated, signIn, navigate]);

  return (
    <SectionContainer>
      <HStack
        alignItems="center"
        justifyContent="center"
        paddingTop={32}
        paddingBottom={8}
        paddingX={4}
      >
        <Spinner size="lg" marginRight={4} />
        <Title>
          {t('common.loading')}
        </Title>
      </HStack>
    </SectionContainer>
  );
};
